import { SpsActionDescriptor, SpsActionMethod, SPS_ACTION_DEFAULTS } from "@spscommerce/ds-shared";
import { usePatchReducer } from "../utils/usePatchReducer";

export function useSpsAction(descriptor: SpsActionDescriptor, fn: () => void): [SpsActionMethod, (newMetadata) => void] {
    const metadata = {
        ...SPS_ACTION_DEFAULTS,
        ...descriptor
    };
    const [state, patchState] = usePatchReducer(metadata);
    Object.assign(fn, state);

    return [fn, (newMetadata) => {
        patchState(newMetadata);
        Object.assign(fn, state);
    }];
}
